module.exports = __webpack_public_path__ + "img/menu-disabled.8e64110f.png";